import styled from "styled-components";

const MainPageContainer = styled.div`
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
`;

export { MainPageContainer };
